"use client";
import Image from "next/image";
import { useTranslations } from 'next-intl';

export default function Footer() {
  const t = useTranslations('Footer');

  return (
    <>
      {/* Top separator border */}
      <div style={{
        width: "100%",
        height: "1px",
        background: "rgba(51, 51, 51, 1)",
      }}></div>
      
      <footer style={{
        background: "#000",
        padding: "60px 24px 40px 24px",
        color: "#fff",
      }}
      className="footer-container">
        <div style={{
          maxWidth: "1400px",
          margin: "0 auto",
        }}>
          {/* Main Footer Content */}
          <div style={{
            display: "grid",
            gridTemplateColumns: "300px 1fr 1fr 1fr 300px",
            gap: "60px",
            marginBottom: "40px",
          }}
          className="footer-grid">
            {/* Logo and Hours */}
            <div className="footer-logo-section">
              <div style={{
                marginBottom: "30px",
              }}>
                <Image 
                  src="/images/mesjaucia-logo.png"
                  alt="MES JAU ČIA"
                  width={180}
                  height={60}
                  style={{ 
                    objectFit: "contain",
                  }}
                  className="footer-logo"
                />
              </div>
              
              <div style={{
                fontSize: "14px",
                color: "rgba(255,255,255,0.8)",
                lineHeight: 1.6,
              }}
              className="footer-hours">
                <div style={{ marginBottom: "8px" }}>
                  <strong style={{ color: "#fff" }}>{t('workingHours.weekdays')}</strong><br />
                  {t('workingHours.weekdaysTime')}
                </div>
                <div>
                  <strong style={{ color: "#fff" }}>{t('workingHours.weekends')}</strong><br />
                  {t('workingHours.weekendsTime')}
                </div>
              </div>
            </div>

            {/* Services Column 1 */}
            <div className="footer-services-col1">
              <div style={{
                fontSize: "18px",
                fontWeight: 600,
                color: "#fff",
                marginBottom: "20px",
              }}
              className="footer-section-title">
                {t('services.title')}
              </div>
              <ul style={{
                listStyle: "none",
                padding: 0,
                margin: 0,
                fontSize: "14px",
                color: "rgba(255,255,255,0.8)",
                lineHeight: 2,
              }}
              className="footer-list">
                {Array.from({ length: 10 }, (_, index) => (
                  <li key={index}>{t(`services.items.${index}`)}</li>
                ))}
              </ul>
            </div>

            {/* Services Column 2 */}
            <div className="footer-services-col2">
              <div style={{
                fontSize: "18px",
                fontWeight: 600,
                color: "#fff",
                marginBottom: "20px",
              }}
              className="footer-section-title footer-hidden-title">
                &nbsp;
              </div>
              <ul style={{
                listStyle: "none",
                padding: 0,
                margin: 0,
                fontSize: "14px",
                color: "rgba(255,255,255,0.8)",
                lineHeight: 2,
              }}
              className="footer-list">
                {Array.from({ length: 10 }, (_, index) => (
                  <li key={index}>{t(`services.items.${index + 10}`)}</li>
                ))}
              </ul>
            </div>

            {/* Information Column */}
            <div className="footer-info-section">
              <div style={{
                fontSize: "18px",
                fontWeight: 600,
                color: "#fff",
                marginBottom: "20px",
              }}
              className="footer-section-title">
                {t('information.title')}
              </div>
              <ul style={{
                listStyle: "none",
                padding: 0,
                margin: 0,
                fontSize: "14px",
                color: "rgba(255,255,255,0.8)",
                lineHeight: 2,
              }}
              className="footer-list">
                {Array.from({ length: 7 }, (_, index) => (
                  <li key={index}>{t(`information.items.${index}`)}</li>
                ))}
              </ul>
            </div>

            {/* Contact Information */}
            <div className="footer-contact-section">
              <div style={{
                display: "flex",
                flexDirection: "column",
                gap: "20px",
              }}
              className="footer-contact-container">
                {/* Email */}
                <div style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  padding: "12px",
                  border: "1px solid #333",
                  borderRadius: "8px",
                }}
                className="footer-contact-item">
                  <Image 
                    src="/images/components/footer-email.png"
                    alt="Email"
                    width={20}
                    height={20}
                  />
                  <div style={{
                    width: "1px",
                    height: "30px",
                    background: "#333",
                  }}
                  className="footer-divider"></div>
                  <div>
                    <div style={{ fontSize: "12px", color: "rgba(255,255,255,0.6)" }}>{t('contact.email')}</div>
                    <div style={{ fontSize: "14px", color: "#fff" }}>info@mesjaucia.lt</div>
                  </div>
                </div>

                {/* Phone */}
                <div style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  padding: "12px",
                  border: "1px solid #333",
                  borderRadius: "8px",
                }}
                className="footer-contact-item">
                  <Image 
                    src="/images/components/footer-phone.png"
                    alt="Phone"
                    width={20}
                    height={20}
                  />
                  <div style={{
                    width: "1px",
                    height: "30px",
                    background: "#333",
                  }}
                  className="footer-divider"></div>
                  <div>
                    <div style={{ fontSize: "12px", color: "rgba(255,255,255,0.6)" }}>{t('contact.phone')}</div>
                    <div style={{ fontSize: "14px", color: "#fff" }}>+37063510000</div>
                  </div>
                </div>

                {/* Address */}
                <div style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  padding: "12px",
                  border: "1px solid #333",
                  borderRadius: "8px",
                }}
                className="footer-contact-item">
                  <Image 
                    src="/images/components/footer-address.png"
                    alt="Address"
                    width={20}
                    height={20}
                  />
                  <div style={{
                    width: "1px",
                    height: "30px",
                    background: "#333",
                  }}
                  className="footer-divider"></div>
                  <div>
                    <div style={{ fontSize: "12px", color: "rgba(255,255,255,0.6)" }}>{t('contact.address')}</div>
                    <div style={{ fontSize: "14px", color: "#fff", lineHeight: 1.3 }}>
                      Ozo g. 12A TECHNOPOLIS,<br />
                      Vilnius, Lietuva
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Section */}
          <div style={{
            borderTop: "1px solid #333",
            paddingTop: "30px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
          className="footer-bottom">
            {/* Copyright */}
            <div style={{
              fontSize: "14px",
              color: "rgba(255,255,255,0.6)",
            }}
            className="footer-copyright">
              {t('copyright')}
            </div>

            {/* Social Media Icons */}
            <div style={{
              display: "flex",
              gap: "15px",
            }}
            className="footer-social">
              <a href="#" style={{
                width: "40px",
                height: "40px",
                background: "#B51F24",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#fff",
                fontSize: "18px",
                textDecoration: "none",
                transition: "all 0.3s ease",
              }}
              className="footer-social-link">
                f
              </a>
              <a href="#" style={{
                width: "40px",
                height: "40px",
                background: "#B51F24",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#fff",
                fontSize: "18px",
                textDecoration: "none",
                transition: "all 0.3s ease",
              }}
              className="footer-social-link">
                📷
              </a>
              <a href="#" style={{
                width: "40px",
                height: "40px",
                background: "#B51F24",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#fff",
                fontSize: "18px",
                textDecoration: "none",
                transition: "all 0.3s ease",
              }}
              className="footer-social-link">
                in
              </a>
            </div>
          </div>
        </div>

        {/* Mobile-Optimized CSS */}
        <style jsx>{`
          .footer-social-link:hover {
            background: #D90D34 !important;
            transform: translateY(-2px);
          }

          @media (max-width: 1024px) {
            .footer-grid {
              grid-template-columns: 1fr 1fr 1fr !important;
              gap: 40px !important;
            }
            
            .footer-logo-section {
              grid-column: 1 / -1 !important;
              text-align: center !important;
              margin-bottom: 20px !important;
            }
            
            .footer-services-col1,
            .footer-services-col2 {
              grid-column: span 1 !important;
            }
            
            .footer-info-section {
              grid-column: span 1 !important;
            }
            
            .footer-contact-section {
              grid-column: 1 / -1 !important;
              margin-top: 20px !important;
            }
          }

          @media (max-width: 768px) {
            .footer-container {
              padding: 40px 16px 30px 16px !important;
            }
            
            .footer-grid {
              grid-template-columns: 1fr !important;
              gap: 30px !important;
              margin-bottom: 30px !important;
            }
            
            .footer-logo-section {
              text-align: center !important;
              margin-bottom: 30px !important;
            }
            
            .footer-logo {
              width: 150px !important;
              height: 50px !important;
            }
            
            .footer-hours {
              text-align: center !important;
              font-size: 13px !important;
            }
            
            .footer-section-title {
              font-size: 16px !important;
              margin-bottom: 15px !important;
              text-align: center !important;
            }
            
            .footer-hidden-title {
              display: none !important;
            }
            
            .footer-list {
              text-align: center !important;
              font-size: 13px !important;
              line-height: 1.8 !important;
            }
            
            .footer-contact-container {
              gap: 15px !important;
            }
            
            .footer-contact-item {
              padding: 16px 12px !important;
              gap: 16px !important;
            }
            
            .footer-divider {
              height: 40px !important;
            }
            
            .footer-bottom {
              flex-direction: column !important;
              gap: 20px !important;
              text-align: center !important;
              padding-top: 20px !important;
            }
            
            .footer-copyright {
              font-size: 12px !important;
              text-align: center !important;
            }
            
            .footer-social {
              gap: 12px !important;
            }
          }

          @media (max-width: 480px) {
            .footer-container {
              padding: 30px 12px 20px 12px !important;
            }
            
            .footer-grid {
              gap: 25px !important;
            }
            
            .footer-logo {
              width: 130px !important;
              height: 45px !important;
            }
            
            .footer-contact-item {
              padding: 14px 10px !important;
              gap: 12px !important;
            }
            
            .footer-contact-item div:last-child {
              font-size: 12px !important;
            }
            
            .footer-contact-item div:last-child div:last-child {
              font-size: 13px !important;
            }
            
            .footer-social-link {
              width: 36px !important;
              height: 36px !important;
              font-size: 16px !important;
            }
          }
        `}</style>
      </footer>
    </>
  );
} 